export default class LegDashTestimonialShowMore {
  constructor(rootElement) {
    this.showMoreBtn = rootElement;

    this.testimonialContainer = rootElement.parentElement.parentElement;
    this.fullTestimonial = this.testimonialContainer.querySelector(
      '.js-testimonial-full'
    );
    this.trimmedTestimonial = this.testimonialContainer.querySelector(
      '.js-testimonial-trimmed'
    );
    this.showLessBtn = this.testimonialContainer.querySelector(
      '.js-testimonial-show-less'
    );

    if (this.showMoreBtn && this.showLessBtn) {
      this.setupEvents(this.showMoreBtn, this.showLessBtn);
      this.setFullTestimonialDefaultHeight();
    }
  }

  setupEvents(showMoreBtn, showLessBtn) {
    showMoreBtn.addEventListener('click', () => {
      this.showFullTestimonial();
    });

    showLessBtn.addEventListener('click', () => {
      this.hideFullTestimonial();
    });
  }

  setFullTestimonialDefaultHeight() {
    const trimmedTestimonialHeight = this.trimmedTestimonial.scrollHeight;
    this.fullTestimonial.style.marginTop = -trimmedTestimonialHeight + 'px';
    this.fullTestimonial.style.maxHeight = trimmedTestimonialHeight + 'px';
  }

  showFullTestimonial() {
    const testimonialHeight = this.fullTestimonial.scrollHeight;
    this.fullTestimonial.classList.remove('--hide-full');
    this.fullTestimonial.style.marginTop = 0;
    this.trimmedTestimonial.classList.add('--hide-trimmed');
    //this.fullTestimonial.style.maxHeight = testimonialHeight + "px";
    this.fullTestimonial.style.maxHeight = '100%';
    //this.fullTestimonial.scrollIntoView();
  }

  hideFullTestimonial() {
    this.fullTestimonial.classList.add('--hide-full');
    this.setFullTestimonialDefaultHeight();
    this.trimmedTestimonial.classList.remove('--hide-trimmed');
    this.trimmedTestimonial.scrollIntoView();
  }
}
